<div class="bar">
  <div class="progress" [style.width.%]="percentage()"></div>
</div>

<section class="flex full-width mt-8">
  <p class="body bold">You're {{ percentage() }}% done</p>
</section>
